import React from "react"
import Link from "next/link"
import { useRouter } from "next/router"

import { hasBreedAndStateQuery } from "./util/helper"
import s from "./LandingCover.module.scss"
import { capitalizeFirstLetterOfTitle } from "@utils"

const ROOT_URL = process.env.NEXT_PUBLIC_ROOT_URL

const ArrowRight = () => <span className={s.arrowRight} />

export const Breadcrumbs = ({
  landingType,
  variables,
  category,
  breed,
  city,
}) => {
  const router = useRouter()
  const isBreedAndState = hasBreedAndStateQuery(router)

  return (
    <div className={s.steps}>
      <Link href={`${ROOT_URL}/puppies-for-sale`} className={s.step}>
        Puppies for Sale
      </Link>

      {landingType === "category" && (
        <>
          <ArrowRight /> {capitalizeFirstLetterOfTitle(category)}
        </>
      )}

      {breed?.slug && !isBreedAndState && (
        <>
          <ArrowRight />
          {breed.name}
        </>
      )}
      {variables?.stateName && !isBreedAndState && (
        <>
          <ArrowRight />
          {variables?.stateName}
        </>
      )}

      {variables?.stateName && landingType === "stateCity" && (
        <>
          <ArrowRight />
          <Link
            href={`${ROOT_URL}/puppies-for-sale/${variables?.slug}`}
            className={s.step}
          >
            {variables?.stateName}
          </Link>
          <ArrowRight /> {city}
        </>
      )}

      {isBreedAndState &&
        landingType !== "breedCity" &&
        landingType !== "stateCity" && (
          <>
            <ArrowRight />
            <Link
              href={`${ROOT_URL}/puppies-for-sale/${breed.slug}`}
              className={s.step}
            >
              {breed.name}
            </Link>
            <ArrowRight /> {variables?.stateName}
          </>
        )}

      {isBreedAndState && landingType === "breedCity" && (
        <>
          <ArrowRight />
          <Link
            href={`${ROOT_URL}/puppies-for-sale/${breed.slug}`}
            className={s.step}
          >
            {breed.name}
          </Link>
          <ArrowRight />
          <Link
            href={`${ROOT_URL}/puppies-for-sale/${breed.slug}/${variables?.stateSlug}`}
            className={s.step}
          >
            {variables?.stateName}
          </Link>
          <ArrowRight /> {city}
        </>
      )}
    </div>
  )
}
